/*
  The transition duration is calculatable from CSS,
  but it's an overkill IMHO
*/
const TRANSITION_DURATION = 500;
const DEFAULT_TAB_WIDTH = 120;

class ButtonTabsCtrl {
  constructor($timeout) {
    'ngInject';

    Object.assign(this, { $timeout });

    this.highlightStyle = null;
    this.highlightInnerStyle = null;
  }

  $onInit() {
    if (!this.tabs.includes(this.activeTab)) {
      this.activeTab = this.tabs[0];
    }

    this.refreshHighlightStyle();
    this.containerStyle = {};
    if (!this.isDynamicWidth) {
      this.containerStyle.width = `${DEFAULT_TAB_WIDTH * this.tabs.length}px`;
    }
  }

  $onChanges() {
    this.refreshHighlightStyle();
  }

  get activeTab() {
    return this._activeTab;
  }

  set activeTab(value) {
    this._activeTab = value;
    this._internalActiveTab = value;
    this.refreshHighlightStyle();
  }

  get internalActiveTab() {
    return this._internalActiveTab;
  }

  set internalActiveTab(value) {
    this.$timeout.cancel(this.timer);
    this._internalActiveTab = value;
    this.refreshHighlightStyle();

    if (this.waitForTransition) {
      this.timer = this.$timeout(() => {
        this.activeTab = value;
      }, TRANSITION_DURATION);
    } else {
      this.activeTab = value;
    }
  }

  refreshHighlightStyle() {
    const count = this.tabs.length;
    const singleTabPercentage = 100 / count;
    const activeTabIndex = this.tabs.indexOf(this.internalActiveTab);

    this.singleTabStyle = {
      width: `${singleTabPercentage}%`,
    };

    this.highlightStyle = {
      width: `${singleTabPercentage}%`,
      ...this._getTransformStyle(`${activeTabIndex * 100}%`),
    };

    this.hightlightClass = {
      first: activeTabIndex === 0,
      last: activeTabIndex === this.tabs.length - 1,
    };

    this.highlightInnerStyle = this._getTransformStyle(`-${activeTabIndex * 100}%`);
  }

  _getTransformStyle(translateX) {
    const value = `translateX(${translateX})`;
    return {
      '-webkit-transform': value,
      transform: value,
    };
  }
}

export default {
  bindings: {
    tabs: '<',
    activeTab: '=',
    waitForTransition: '<?',
    isDynamicWidth: '<?',
  },
  template: `
    <div ng-style="ctrl.containerStyle">
      <div class="button-tabs-options">
        <button ng-style="ctrl.singleTabStyle" type="button" class="btn btn-lg" ng-repeat="tab in ctrl.tabs" ng-click="ctrl.internalActiveTab = tab">
          {{ tab | uppercaseFirst }}
        </button>
      </div>
      <div class="button-tabs-highlight" ng-style="ctrl.highlightStyle" ng-class="ctrl.hightlightClass" ng-if="ctrl.highlightStyle">
        <div ng-style="ctrl.highlightInnerStyle">
          <button type="button" class="btn btn-lg" ng-repeat="tab in ctrl.tabs">
            {{ tab | uppercaseFirst }}
          </button>
        </div>
      </div>
    </div>
  `,
  controllerAs: 'ctrl',
  controller: ButtonTabsCtrl,
};
